import PropTypes from "prop-types";
import { TextInputReadOnly } from "components/form_new";
import { propOr } from "ramda";
import useTranslate from "hooks/use-translate-language";

const Physician = ({ physicians }) => {
  const translate = useTranslate();

  // Only use physicians array
  const physiciansToDisplay = physicians ?? [];

  if (physiciansToDisplay.length === 0) {
    return (
      <div className="profile-panel">
        <div className="profile-panel-content">
          <p>{translate("noPhysicianInformation")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-panel">
      <hr
        style={{
          margin: "5px",
          border: "none",
          borderTop: "2px solid #dee2e6"
        }}
      />
      {physiciansToDisplay.map((physician, index) => {
        const homeAddress = propOr({}, "address", physician);

        return (
          <div key={physician?.product_line || index}>
            <h2 style={{ marginBottom: 15, color: "#337abb" }}>
              {physician.product_line} {translate("physician")}
            </h2>

            <div className="profile-panel-content">
              <TextInputReadOnly
                label={translate("physicianName")}
                value={propOr("", "name", physician)}
              />

              <TextInputReadOnly
                label={translate("phoneNumber")}
                value={propOr("", "phone", physician)}
              />
              <TextInputReadOnly
                label={translate("fax")}
                value={propOr("", "fax", physician)}
              />
              <TextInputReadOnly
                label={translate("npi")}
                value={propOr("", "npi", physician)}
              />

              <TextInputReadOnly
                label={translate("streetAddress")}
                value={homeAddress.street_address || ""}
              />

              <TextInputReadOnly
                label={translate("streetAddress2")}
                value={homeAddress.street_address2 || ""}
              />

              <TextInputReadOnly
                label={translate("city")}
                value={homeAddress.city || ""}
              />
              <TextInputReadOnly
                label={translate("state")}
                value={homeAddress.state || ""}
              />
              <TextInputReadOnly
                label={translate("zipCode")}
                value={homeAddress.zip || ""}
              />
              <TextInputReadOnly
                label={translate("notes")}
                value={propOr("", "note", physician)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
Physician.propTypes = {
  physicians: PropTypes.arrayOf(
    PropTypes.shape({
      product_line: PropTypes.string,
      name: PropTypes.string,
      phone: PropTypes.string,
      fax: PropTypes.string,
      npi: PropTypes.string,
      address: PropTypes.shape({
        street_address: PropTypes.string,
        street_address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.string
      })
    })
  )
};

export default Physician;
